import React from "react";

import CommonPopup from "..";
import CommonButton from "../../Button";
import { MyProfileWorkSpaceIcon } from "../../../pages/MyInfo";

type Props = { popup?: string; onClose?: () => void };

export default function WorkSpaceYetPopup({ popup, onClose }: Props) {
  return (
    <CommonPopup
      isOpen={popup === "workSpaceYet"}
      onClose={onClose}
      title={"근무 위치 미설정"}
      padding={0}
    >
      <div className="flex flex-col gap-5 items-center">
        <div className="flex flex-col py-2.5 gap-2.5 items-center label-grey-small">
          <MyProfileWorkSpaceIcon />
          근무 위치를 설정해주세요
        </div>
        <CommonButton className="bottom-button" onClick={onClose}>
          확인
        </CommonButton>
      </div>
    </CommonPopup>
  );
}
